






























































import { Mixins, Component, Ref } from "vue-property-decorator";
import Step from "./Step.vue";
import ActionBar from "./ActionBar.vue";
import GrpTargetMixin from "@/mixins/http/Grp/Target";
import GuestPanel from "./GuestPanel.vue";
import GenderPanel from "./GenderPanel.vue";
import ChildrenPanel from "./ChildrenPanel.vue";
import BuyersPanel from "./BuyersPanel.vue";
import AgePanel from "./AgePanel.vue";
import GrpTagChoice from "@/interfaces/GrpTagChoice";
import { Target } from "@/models";

@Component({
  components: {
    Step,
    ActionBar,
    GuestPanel,
    GenderPanel,
    ChildrenPanel,
    BuyersPanel,
    AgePanel,
  },
})
export default class GrpTargetCreate extends Mixins(GrpTargetMixin) {
  step = 0;
  targetName = "";
  @Ref() readonly nameEditor!: HTMLInputElement;
  @Ref() readonly guestPanel!: GuestPanel;
  @Ref() readonly genderPanel!: GenderPanel;
  @Ref() readonly buyersPanel!: BuyersPanel;
  @Ref() readonly childrenPanel!: ChildrenPanel;
  @Ref() readonly agePanel!: AgePanel;
  guestTag: GrpTagChoice | null = null;
  genderTag: GrpTagChoice | null = null;
  buyersTag: GrpTagChoice | null = null;
  childrenTag: GrpTagChoice | null = null;
  ageTag: GrpTagChoice | null = null;

  async init() {
    this.step = 0;
    this.targetName = "";
    this.guestTag = {
      tag: "",
      type: "scalar",
      isValid: false,
    };
    this.genderTag = {
      tag: [],
      type: "list",
      isValid: false,
    };
    this.buyersTag = {
      tag: "",
      type: "scalar",
      isValid: false,
    };
    this.childrenTag = {
      tag: "",
      type: "scalar",
      isValid: true,
    };
    this.ageTag = {
      tag: [],
      type: "list",
      isValid: false,
    };

    await this.$nextTick();
    this.guestPanel.init(this.guestTag);
    this.nameEditor.focus();
  }

  async goToStep(step: number) {
    this.step = step;
    await this.$nextTick();
    if (step == 0) {
      this.guestPanel.init(this.guestTag);
    }
    if (step == 1) {
      this.genderPanel.init(this.genderTag);
    }
    if (step == 2) {
      this.buyersPanel.init(this.buyersTag);
    }
    if (step == 3) {
      this.childrenPanel.init(this.childrenTag);
    }
    if (step == 4) {
      this.agePanel.init(this.ageTag);
    }
  }

  get validateTagSelection() {
    if (this.step == 0) {
      return this.guestTag?.isValid;
    }
    if (this.step == 1) {
      return this.genderTag?.isValid;
    }
    if (this.step == 2) {
      return this.buyersTag?.isValid;
    }
    if (this.step == 3) {
      return this.childrenTag?.isValid;
    }
    if (this.step == 4) {
      return this.ageTag?.isValid && this.targetName != "";
    }
    return false;
  }

  get guestSelected() {
    return this.guestTag?.tag == "guests";
  }

  get buyersSelected() {
    return this.buyersTag?.tag == "buyers";
  }

  get childrenSelected() {
    return this.childrenTag?.tag != "";
  }

  onGuestChoice(choice: GrpTagChoice) {
    this.guestTag = choice;
  }

  onGenderChoice(choice: GrpTagChoice) {
    this.genderTag = choice;
  }

  onBuyersChoice(choice: GrpTagChoice) {
    this.buyersTag = choice;
    if (this.childrenTag) {
      this.childrenTag.tag = "";
    }
  }

  onChildrenChoice(choice: GrpTagChoice) {
    this.childrenTag = choice;
  }

  onAgeChoice(choice: GrpTagChoice) {
    this.ageTag = choice;
  }

  onCloseClick() {
    this.$emit("cancel");
  }

  async onSave() {
    const tagList = this.generateTagList();
    const model = {
      name: this.targetName,
      tags: tagList,
    };
    const savedModel = await this.createTarget(model);
    this.$emit("save", savedModel);
  }

  private generateChildrenTags(): Array<string[]> {
    const result: Array<string[]> = [];
    (this.genderTag?.tag as string[]).forEach((genderTag) => {
      result.push([
        this.guestTag?.tag as string,
        genderTag,
        this.childrenTag?.tag as string,
        this.buyersTag?.tag as string,
      ]);
    });
    return result;
  }

  private generateGuestTags(): Array<string[]> {
    const result: Array<string[]> = [];
    (this.ageTag?.tag as string[]).forEach((ageTag) => {
      (this.genderTag?.tag as string[]).forEach((genderTag) => {
        result.push(["guests", genderTag, ageTag]);
      });
    });
    return result;
  }

  private generateNoGuestTags(): Array<string[]> {
    const result: Array<string[]> = [];
    (this.ageTag?.tag as string[]).forEach((ageTag) => {
      (this.genderTag?.tag as string[]).forEach((genderTag) => {
        result.push([
          "no_guests",
          this.buyersTag?.tag as string,
          genderTag,
          ageTag,
        ]);
      });
    });
    return result;
  }

  private generateTagList(): Array<string[]> {
    if (this.childrenSelected) {
      return this.generateChildrenTags();
    } else {
      if (this.guestTag?.tag == "guests") {
        return this.generateGuestTags();
      } else {
        return this.generateNoGuestTags();
      }
    }
  }
}
